import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import PatientProfileLite from './PatientProfileLite';
import { User } from '../../../../graphql/graphql';
import { Size } from '../../../../Enums/Size.enum';

interface Props extends BaseModalProps {
	patient: User;
	caseId?: string;
}

const PatientProfileLiteModal: React.FC<Props> = props => {
	return (
		<BaseModal {...props} size={Size.LG} title='base.shared.patientProfile'>
			<PatientProfileLite patient={props.patient} caseId={props.caseId} />
		</BaseModal>
	);
};

export default PatientProfileLiteModal;
